/**
 * L4 — centralized portfolio score / capacity formatting.
 */

/** Format a numeric score to two decimal places. Returns em-dash for nullish. */
export function formatScore2Dec(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return value.toFixed(2);
}

/** Format capacity in MW (0 decimals when whole, else 1). */
export function formatCapacityMw(value: number | null | undefined): string {
  if (value == null || !Number.isFinite(value)) return '—';
  return Number.isInteger(value) ? `${value}` : value.toFixed(1);
}

/** Relative time label for ISO timestamps. */
export function formatRelativeTime(iso: string | null | undefined, nowMs = Date.now()): string {
  if (!iso) return 'never';
  const then = new Date(iso).getTime();
  if (!Number.isFinite(then)) return 'unknown';
  const diffSec = Math.max(0, Math.floor((nowMs - then) / 1000));
  if (diffSec < 60) return 'just now';
  const diffMin = Math.floor(diffSec / 60);
  if (diffMin < 60) return `${diffMin}m ago`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 48) return `${diffHr}h ago`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay < 14) return `${diffDay}d ago`;
  return new Date(iso).toLocaleDateString();
}
